import { useState } from 'react'
import { NavigationSidebar } from './NavigationSidebar'
import React from 'react'
import './NavigationWithSideBar.scss'
import classNames from 'classnames'

const ContentArea = React.memo(({ sections, activeSection }: { sections: ClickNavigationProps[]; activeSection: string }) => {
  return (
    <div className='scroll-navigation__sections'>
      {sections.map((section) => {
        if (section.id === activeSection) {
          const SectionContent = section.content
          return <SectionContent key={section.id} />
        }
      })}
    </div>
  )
})

export interface ClickNavigationProps {
  id: string
  label: string
  title?: string
  content: React.ComponentType
  disabled?: boolean
}

interface ClickNavigation {
  sections: ClickNavigationProps[]
  defaultActiveSectionId: string
  className?: string
}

export const ClickNavigation: React.FC<ClickNavigation> = ({ sections, defaultActiveSectionId, className }) => {
  const [activeSection, setActiveSection] = useState<string>(defaultActiveSectionId)
  return (
    <div className={classNames('scroll-navigation__container', className)}>
      <NavigationSidebar
        sections={sections.map(({ id, label, disabled }) => ({ id, label, disabled }))}
        activeSection={activeSection}
        onSectionClick={setActiveSection}
      />
      <ContentArea sections={sections} activeSection={activeSection} />
    </div>
  )
}
